import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { EventRecordFilterContext } from '../../contexts/EventRecordFilterContext'

export const EventRecordSelectorForm = () => {
  const { dispatch } = useContext(EventRecordFilterContext)
  const { t } = useTranslation()

  const handleInputValueChanged = (event) => {
    const {name, value} = event.target;
    const [filterType, subname] = name.split(/\.(.+)/)
    dispatch({
      type: filterType,
      name: subname,
      value: value.trim(),
    });
  }

  const handleCheckedStateChanged = (event) => {
    const {name, checked} = event.target;
    const [filterType, subname] = name.split(/\.(.+)/)
    dispatch({
      type: filterType,
      name: subname,
      value: checked,
    });
  }

  return (
    <>
      <div className="multiinput_container">
        <label className="datatable_select_radio" htmlFor="eventDataFilter.epicentralDistance.enabled">
          <input 
            type="checkbox" id="eventDataFilter.epicentralDistance.enabled"
            name="epicentralDistance.enabled"
            className="filled-in with-gap"  
            onChange={handleCheckedStateChanged}
          />
          <span>{t('page.kesmdb.epicentralDistance')} (km)</span>
        </label>
        <div className="inline-block">
          <input
            type="text" name="epicentralDistance.min"
            aria-label="진앙 거리 최소값"
            placeholder="0"
            className="multiinput"
            onBlur={handleInputValueChanged}
          />
          &nbsp; ~ &nbsp;
          <input
            type="text" name="epicentralDistance.max"
            placeholder="500"
            className="multiinput"
            aria-label="진앙 거리 최대값"
            onBlur={handleInputValueChanged}
          />
        </div>
      </div>
      <div className="multiinput_container">
        <label className="datatable_select_radio" htmlFor="eventDataFilter.horizontalPga.enabled">
          <input 
            type="checkbox" id="eventDataFilter.horizontalPga.enabled"
            name="horizontalPga.enabled"
            className="filled-in with-gap"  
            onChange={handleCheckedStateChanged}
          />
          <span>{t('page.kesmdb.horizontalDirection')} PGA (cm/s<sup>2</sup>)</span>
        </label>
        <div className="inline-block">
          <input
            type="text" name="horizontalPga.min"
            aria-label="수평방향 PGA 최소값"
            placeholder="1"
            className="multiinput"
            onBlur={handleInputValueChanged}
          />
          &nbsp; ~ &nbsp;
          <input
            type="text" name="horizontalPga.max"
            placeholder="1000"
            className="multiinput"
            aria-label="수평방향 PGA 최대값"
            onBlur={handleInputValueChanged}
          />          
        </div>
      </div>
      <div className="multiinput_container">
        <label className="datatable_select_radio" htmlFor="eventDataFilter.verticalPga.enabled">
          <input 
            type="checkbox" id="eventDataFilter.verticalPga.enabled"
            name="verticalPga.enabled"
            className="filled-in with-gap"  
            onChange={handleCheckedStateChanged}
          />
          <span>{t('page.kesmdb.verticalDirection')} PGA (cm/s<sup>2</sup>)</span>
        </label>
        <div className="inline-block">
          <input
            type="text" name="verticalPga.min"
            aria-label="수직방향 PGA 최소값"
            placeholder="1"
            className="multiinput"
            onBlur={handleInputValueChanged}
          />
          &nbsp; ~ &nbsp;
          <input
            type="text" name="verticalPga.max"
            placeholder="1000"
            className="multiinput"
            aria-label="수직방향 PGA 최대값"
            onBlur={handleInputValueChanged}
          />          
        </div>
      </div>
      <div className="multiinput_container">
        <div className="left multiinput_container">
          <label className="datatable_select_radio" htmlFor="eventDataFilter.sensorType.enabled">
            <input 
              type="checkbox" id="eventDataFilter.sensorType.enabled"
              name="sensorType.enabled"
              className="filled-in with-gap"  
              onChange={handleCheckedStateChanged}
            />
            <span>{t('form.eventRecord.sensorType.title')}:</span>
          </label>
          <label className="datatable_select_radio" htmlFor="eventDataFilter.sensorTypeSelector.surface">
            <input type="radio" id="eventDataFilter.sensorTypeSelector.surface"
              name="sensorType.value" 
              value="surface"
              className="with-gap"
              onChange={handleInputValueChanged}
            />
            <span>{t('form.eventRecord.sensorType.surface')}</span>
          </label>
          <label className="datatable_select_radio" htmlFor="eventDataFilter.sensorTypeSelector.borehole">
            <input type="radio" id="eventDataFilter.sensorTypeSelector.borehole"
              name="sensorType.value" 
              value="borehole"
              className="with-gap"  
              onChange={handleInputValueChanged}
            />
            <span>{t('form.eventRecord.sensorType.borehole')}</span>
          </label>
        </div>
      </div>
    </>
  )
}